"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionFormCtrl = void 0;
var core_api_1 = require("@ikegps/core-api");
var i18n_1 = require("../../i18n");
var index_1 = require("../../services/index");
var page_state_1 = require("../../state/page.state");
var collection_form_modal_1 = require("../collection.form.modal/collection.form.modal");
exports.CollectionFormCtrl = {
    canDisplay: function () {
        return index_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE);
    },
    showUpdateFormModal: function () {
        var collections = page_state_1.CurrentState.Tag.collections;
        var modal = new collection_form_modal_1.CollectionFormModal({
            title: i18n_1.T.COLLECTION_UPDATE_FORM_TITLE,
            confirm: i18n_1.T.COLLECTION_UPDATE_FORM,
            success: {
                key: i18n_1.T.COLLECTION_UPDATE_FORM_SUCCESS
            }
        }, collections);
        modal.open();
    }
};
//# sourceMappingURL=collection.form.ctrl.js.map